import {axios} from "../../core";

export default {
    getAll: () => axios.get("/dialogs"),
    create: ({text, cat_id}) => axios.post("/user/dialogs/create", {text, cat_id}),
    confirmed: ({dialog_id}) => axios.put(`/user/dialogs/approve/${dialog_id}`),
    rating: ({dialog_id, vote, text}) => axios.put(`/user/dialogs/rating/${dialog_id}`, {vote, text})
};
